import { useCallback, useEffect, useState } from 'react';

export default function usePointAwardAnimation() {
  const [awardAnimation, setAwardAnimation] = useState({ sequence: 0, studentIds: [] });

  useEffect(() => {
    if (!awardAnimation.studentIds.length) return undefined;
    const timeout = window.setTimeout(() => {
      setAwardAnimation((current) => current.sequence === awardAnimation.sequence
        ? { ...current, studentIds: [] }
        : current);
    }, 1400);
    return () => window.clearTimeout(timeout);
  }, [awardAnimation]);

  const showPointAwards = useCallback((studentIds) => {
    if (!studentIds.length) return;
    setAwardAnimation((current) => ({
      sequence: current.sequence + 1,
      studentIds: studentIds.map(String),
    }));
  }, []);

  const clearPointAwards = useCallback(() => {
    setAwardAnimation((current) => ({ ...current, studentIds: [] }));
  }, []);

  return { awardAnimation, showPointAwards, clearPointAwards };
}
